// The server's custom emoji for the picker, from the store (the worker keeps `custom_emoji` synced).
// Cached at module level so a second open paints its custom section on the first frame.
import { data } from '../../../bridge/client';
import type { CustomEmojiEntry } from '../../../data/features/emoji';
import { useLive } from '../../hooks';

let cached: CustomEmojiEntry[] | undefined;

export function useCustomEmojiList(): CustomEmojiEntry[] {
  const { value } = useLive(() => data.call('customEmojiList'), ['customEmoji'], [], { initial: () => cached });
  if (value) cached = value;
  return value ?? [];
}
